/**
 * ONE_TRUST const symbols.
 * @constant
 * @type {Object}
 */


const ONE_TRUST = {
    CDN: 'cdn',
    DOMAIN_ID: 'domainId',
    COUNTRY: 'country',
    REGION: 'region',
    LANG: 'lang',
    ENABLE: 'enable',
    DISPLAY: 'display',
    APPS_FLAYER: 'appsflayer',
    PUSH: 'push',

    USER_RESPONSE: 'one_trust_user_response',
    DMA_BANNER: 'DMA_banner',
    CATEGORY: 'Hybrid_OneTrust'
};


export {ONE_TRUST};